import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const toggleButtonTheme: Pick<Components<Theme>, 'MuiToggleButton'> = {
  MuiToggleButton: {
    styleOverrides: {
      root: {
        '.svg-inline--fa': {
          fontSize: '1.125rem', // toggle button controls the size of icon: size remains the same for all button sizes
        },
      },
    },
  },
};
